export default __webpack_public_path__ + "static/media/overview_elite.11efaa00.gif";